import type React from 'react';

import { CmsHtml } from 'src/app/shared/components/cms';

import { usePageBody } from './hooks/usePageBody';

export const PageBody: React.FC = () => {
	const {
		data: { html, styles },
	} = usePageBody();
	return <CmsHtml html={html} styles={styles} />;
};
